import {
  ModalType,
  useModalContext,
  useFeatureFlagContext,
} from 'modules/campaigns/editor/context';
import { BUTTON_SIZES, SecondaryButton } from 'ui/button';
import { Send } from 'ui/icons';
import { CampaignPopover } from '../../../CampaignPopover';
import { CampaignPermissionCheck } from '../../CampaignPermissionCheck';

export const DisplayCampaignNowAction = () => {
  const { openModal } = useModalContext();
  const { isSuspendSendsEnabled } = useFeatureFlagContext();

  return (
    <CampaignPermissionCheck action="display" ChildWrapper={CampaignPopover}>
      <SecondaryButton
        data-test="display-now-button"
        size={BUTTON_SIZES.LARGE}
        isDisabled={isSuspendSendsEnabled}
        onClick={() => openModal(ModalType.DisplayEligibilityCampaign, { asDisplayNow: true })}
      >
        <Send />
        Start now
      </SecondaryButton>
    </CampaignPermissionCheck>
  );
};
